import type { AssetsShareUserSchemaWithId } from '@iconik-io/iconik-api/src/services/assets';

import ContextMenu from '../../../components/context_menu/context_menu';
import contextMenuConnector from '../../../components/context_menu/context_menu_connector';
import type {
  ContextMenuItemDefinition,
  GetDefinition,
} from '../../../components/context_menu/types';
import { DELETE_SHARE_USERS_MODAL } from '../../../constants/modals';
import { openModal } from '../../../ducks/modals_manager/slice';
import { SHARE_USER_EMAIL_PLACEHOLDER } from '../../../ducks/share/constants';
import { ICONS } from '../../../icons/icon';
import type { AppDispatch } from '../../../store/types';

export const getDefinition: GetDefinition<AssetsShareUserSchemaWithId> = (
  props,
) => {
  const contextItems = props.contextItems;

  const items: ContextMenuItemDefinition[] = [];
  if (contextItems[0]?.email !== SHARE_USER_EMAIL_PLACEHOLDER) {
    items.push({
      label: 'Delete Share Participant…',
      action: () => (dispatch: AppDispatch) =>
        dispatch(
          openModal({
            id: DELETE_SHARE_USERS_MODAL,
            contextItems,
          }),
        ),
      icon: ICONS.TrashBin,
    });
  }

  return {
    items,
  };
};

const SharePanelUsersContextMenu =
  contextMenuConnector(getDefinition)(ContextMenu);

export default SharePanelUsersContextMenu;
